import React from 'react'
import Link from '../Link'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import styled from 'styled-components'
import Query from './Query'
import { FaChevronRight } from 'react-icons/fa'
import { ThemeConsumer } from '../../state'
import Image from '../Image'

const ContactFormContainer = styled.div`
  flex: 2;
  padding-left: 2rem;

  @media screen and (max-width: 900px) {
    padding-left: 0;
  }
`
const Links = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    flex: 1;
    flex-direction: column;
  }
  li {
    margin: 0;
    flex: 1 1 50%;
    justify-content: center;
    align-items: center;
    .req-cta .icon img {
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
  }
  li,
  a {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
  }
  a {
    min-height: 420px;
    justify-content: center;
    @media (max-width: 1200px) {
      min-height: 500px;
    }
    @media (max-width: 768px) {
      min-height: 300px;
    }
  }
  p {
    font-size: 1.6rem;
    font-weight: 300;
    text-transform: none;
    margin-top: auto;
    align-self: flex-end;
    max-width: 100%;
  }
  .req-cta {
    margin: 2rem;
    padding: 3rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    color: inherit;
    border: 1px solid transparent;
    .icon {
      height: 100%;
      width: 100%;
      min-height: 125px;
      padding: 2rem;
      margin-top: auto;
      margin-bottom: 1rem;
    }
    .icon img {
      width: auto;
    }
    .title {
      font-size: 1.8rem;
      margin-top: 15px;
    }
    &:hover {
      background: none;
      border: 1px solid rgba(255, 255, 255, 0.3);
    }
  }
`
const AlignMyChevron = styled(FaChevronRight)`
  vertical-align: middle;
  padding-bottom: 0.2rem;
`

export default () => (
  <ThemeConsumer>
    {({ theme }) => (
      <Query
        render={(content) =>
          console.log(content) || (
            <Layout>
              <Hero>
                <HeroTitle useH1>{content.title}</HeroTitle>
              </Hero>
              <ContactFormContainer>
                <Links>
                  <li>
                    <Link href="https://cardano.org" className="req-cta">
                      <div className="icon">
                        <Image height="139.4px" src="/cardano-logo.svg" />
                      </div>
                      <p>{content.projects.cardano}</p>
                      <div className="title">
                        {content.projects.link_text} <AlignMyChevron />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={
                        content.projects.daedalus_link ||
                        'https://daedaluswallet.io'
                      }
                      className="req-cta"
                    >
                      <div className="icon">
                        <Image height="122.1px" src="/daedalus-logo.svg" />
                      </div>
                      <p>{content.projects.daedalus}</p>
                      <div className="title">
                        {content.projects.link_text} <AlignMyChevron />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link href="https://atalaprism.io" className="req-cta">
                      <div className="icon">
                        <Image height="90.8px" src="/atala-logo.svg" />
                      </div>
                      <p>{content.projects.atala}</p>
                      <div className="title">
                        {content.projects.link_text} <AlignMyChevron />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link href="https://mantisclient.io" className="req-cta">
                      <div className="icon">
                        <Image height="90.9px" src="/mantis-logo.svg" />
                      </div>
                      <p>{content.projects.mantis}</p>
                      <div className="title">
                        {content.projects.link_text} <AlignMyChevron />
                      </div>
                    </Link>
                  </li>
                </Links>
              </ContactFormContainer>
            </Layout>
          )
        }
      />
    )}
  </ThemeConsumer>
)
